<template>
    <div style="padding-top: 65px;height: 100vh;width:100%;overflow: scroll" >
        <el-row>
            <el-col :span="24" style="height: 60px;background-color:#EAEAEA;width: 100vw;box-shadow: inset 0px 10px 10px #DDDDDD;z-index: 2">
                <div style="">
                    <i class="el-icon-d-arrow-left" style="font-size: 20px;line-height: 58px; text-align: left;padding-left:40px;" @click="this.$router.go(-1)">
                        <i style="font-size: 18px;font-style: normal;font-weight: bold;"> {{base[0]}}</i>
                    </i>

                </div>
                <h1 style="text-align: center" >{{title}}</h1>
                <div v-html="describe" style="height: 80vh;line-height: 24px;padding: 10px"></div>
            </el-col>



        </el-row>
    </div>
</template>

<script>
    import request from "@/utils/request";
    export default {
        name: "NewsDescription",
        data(){

            return{
                isPC:true,
                base:['返回上一级'],
                sn:'',
                list:[],
                describe:'',
                title:''

            }
        },
        methods:{
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            }
        },
        mounted(){
            if (this._isMobile()) {
                this.isPC=false;

            } else {
                // alert("pc端");
                // this.$router.replace('/test');
                this.isPC=true;
            }
            this.describe=this.$route.query.describe
            this.title=this.$route.query.title
        },


    }
</script>

<style scoped>
    .hidden{
        overflow: hidden !important;
    }
    .lunbotu{
     height: calc(100vh - 130px);
    }
</style>